import React, { useContext } from "react";
import {FaFacebookF , FaTwitter, FaRegCopyright} from 'react-icons/fa';
import './footer.css'
import {useNavigate} from 'react-router-dom';
import { NavigatorContext } from "../contexts/NavigatorContext";


export default function Footerfunc(){
    
    const navigate = useNavigate();
    const {setParam} = useContext(NavigatorContext);
    const handlebooking = (e)=>{
        e.persist();
        setParam(e.target.id.slice(1,-1));
        navigate(e.target.id);
        window.scrollTo(0, 0);
    }
    const handleAbout = ()=>{
        window.scrollTo(0, 0);
        navigate("/about");
    }
    return (
        <div className="footer">
        <div className="information">
            <div className="block">
                <h5>PRODUCT OFFERING</h5>
                <div>
                    <span id="/flights" onClick={handlebooking}>Book Flights,</span>
                    <span id="/hotels" onClick={handlebooking}>Book Hotels,</span>
                    <span id="/holidays" onClick={handlebooking}>Book Holiday Packages,</span>
                    <span id="/homes" onClick={handlebooking}>Book Homes & Villas,</span>
                    <span id="/trains" onClick={handlebooking}>Book Train Tickets,</span>
                    <span id="/cabs" onClick={handlebooking}>Book a Cab,</span>
                    <span id="/forexs" onClick={handlebooking}>Foreign Exchange,</span>
                    <span id="/charters" onClick={handlebooking}>Book a Chartered</span>
                </div>
            </div>
           
            <div className="block">
                <h5>IMPORTANT LINKS</h5>
                <div>
                    <span id="/flights" onClick={handlebooking}>Flights,</span>
                    <span id="/hotels" onClick={handlebooking}>Hotels,</span>
                    <span id="/holidays" onClick={handlebooking}>Holiday Packages,</span>
                    <span id="/homes" onClick={handlebooking}>Homes & Villas,</span>
                    <span id="/trains" onClick={handlebooking}>Train Tickets,</span>
                    <span id="/cabs" onClick={handlebooking}>Cab Ride,</span>
                    <span id="/forexs" onClick={handlebooking}>Foreign Exchange,</span>
                    <span id="/charters" onClick={handlebooking}>Chartered Flights</span>
                </div>
            </div>
            <div className="block">
                <h5>QUICK LINKS</h5>
                <div>
                    <span id="/flights" onClick={handlebooking}>Flight Tickets,</span>
                    <span id="/hotels" onClick={handlebooking}>Hotel & Lounges,</span>
                    <span id="/holidays" onClick={handlebooking}>Holiday Packages for all,</span>
                    <span id="/homes" onClick={handlebooking}>Homes & Villas booking,</span>
                    <span id="/forexs" onClick={handlebooking}>Foreign Exchange,</span>
                    <span id="/charters" onClick={handlebooking}>Book a Chartered</span>
                </div>
            </div>
            <div className="block">
                <h5>MAKE MY TRIP</h5>
                <div className="block2">
                    <span onClick={handleAbout}>About us,</span>
                    <a style={{color:'black'}} href="https://www.redbus.in/" target="_blank"><span>Partners- Redbus,</span></a>
                    <a style={{color:'black'}} href="https://www.goibibo.com/" target="_blank"><span>Partners- Goibibo</span></a>
                </div>
            </div>
        </div>
            
        <div className="social">
            <div className="social-icon">
                <a href="https://www.facebook.com/makemytrip" target="_blank"><FaFacebookF style={{fontSize:"50px"}}/></a>
                <a href="https://twitter.com/makemytrip" target="_blank"><FaTwitter style={{fontSize:"50px"}}/></a>
            </div>
            <div>
                <div className="copyright">
                    <FaRegCopyright style={{marginTop:"10px"}}/>
                    <h3>MMT</h3>
                </div>
                <div className="copyright"><p>Country <h5>India US</h5></p></div>
            </div>
        </div>
    </div>
    )
}